module.exports = __webpack_public_path__ + "static/media/pla_loc_att.3bfd48a9.png";